<template>
  <div>
    <Manage></Manage>
    <EventModal></EventModal>
    <EventDetailModal></EventDetailModal>
    <ModalChangeOrderDetail></ModalChangeOrderDetail>
    <CustomMessageModal></CustomMessageModal>
    <EventStaffingDetail></EventStaffingDetail>
    <ManageEmailModal></ManageEmailModal>
    <EmailHistoriesManagement></EmailHistoriesManagement>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import Manage from '../../../components/eventManagement/main/Manage.vue';
  import EventDetailModal from '../../../components/modal/event/EventDetailModal';
  import EventModal from '../../../components/modal/Modal';
  import ModalChangeOrderDetail from '../../../components/modal/ModalChangeOrderDetail';
  import CustomMessageModal from '../../../components/modal/CustomMessageModal';
  import EventStaffingDetail from '../../staffing/EventStaffingDetail';
  import ManageEmailModal from '../../../views/email/ManageEmail';
  import EmailHistoriesManagement from '../../../views/email/EmailHistoriesManagement';

  import Icon from 'vue-awesome/components/Icon';

  import 'vue-awesome/icons/file-excel-o';
  import 'vue-awesome/icons/question-circle-o';
  import 'vue-awesome/icons/sort-down';
  import 'vue-awesome/icons/users';

  export default {
    name: 'c-manage-client-view',
    components: {
      Icon,
      Manage,
      EventDetailModal,
      EventModal,
      ModalChangeOrderDetail,
      CustomMessageModal,
      EventStaffingDetail,
      ManageEmailModal,
      EmailHistoriesManagement
    },
    props: {},
    data () {
      return {};
    },
    computed: {
      ...mapGetters({})
    },
    methods: {
      ...mapActions({})
    },
    watch: {}
  };
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';
</style>



// WEBPACK FOOTER //
// Manage.vue?6e572490